export function throttle(ms) {
    return function (_target, _propertyKey, descriptor) {
        const originalMethod = descriptor.value;
        const lockMap = new WeakMap();
        descriptor.value = function (...args) {
            if (lockMap.get(this))
                return;
            originalMethod.apply(this, args);
            lockMap.set(this, true);
            setTimeout(() => {
                lockMap.set(this, false);
            }, ms);
        };
        return descriptor;
    };
}
//# sourceMappingURL=throttle.js.map